var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9796 6.91804L8.97963 17.918C8.88383 18.0142 8.76998 18.0905 8.64463 18.1425C8.51928 18.1946 8.38489 18.2214 8.24916 18.2214C8.11344 18.2214 7.97905 18.1946 7.8537 18.1425C7.72835 18.0905 7.6145 18.0142 7.5187 17.918L2.7062 13.1055C2.61027 13.0096 2.53418 12.8957 2.48226 12.7704C2.43035 12.6451 2.40363 12.5107 2.40363 12.3751C2.40363 12.2394 2.43035 12.1051 2.48226 11.9797C2.53418 11.8544 2.61027 11.7405 2.7062 11.6446C2.80212 11.5487 2.916 11.4726 3.04134 11.4207C3.16667 11.3688 3.301 11.342 3.43666 11.342C3.57233 11.342 3.70666 11.3688 3.83199 11.4207C3.95733 11.4726 4.07121 11.5487 4.16713 11.6446L8.25002 15.7275L18.5204 5.45882C18.7141 5.26509 18.9769 5.15625 19.2509 5.15625C19.5249 5.15625 19.7876 5.26509 19.9814 5.45882C20.1751 5.65255 20.2839 5.91531 20.2839 6.18929C20.2839 6.46327 20.1751 6.72603 19.9814 6.91976L19.9796 6.91804Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/checkMark.54de585a44ce50f375a9fe63be22860d.svg";
export { ForwardRef as ReactComponent };